module.exports = "<h2 id=\"component-description\">Component Description</h2>\n<p>A Nessie IconButton is a Icon inside a HTML <code>&lt;button type=&quot;button&quot;&gt;</code> element.</p>\n<h2 id=\"example-usage\">Example Usage</h2>\n<pre><code>&lt;IconButton iconType=&quot;right&quot;&gt;\n    Next page\n&lt;/IconButton&gt;\n</code></pre><p>Note that the “Next page” label is not rendered, instead it is used as the\n<code>aria-label</code> attribute of the icon <code>&lt;div&gt;</code>.</p>\n";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./node_modules/markdown-loader!./src/IconButton/README.md
// module id = 357
// module chunks = 0